<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2025-07-16 10:33:56
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2025-08-08 16:57:25
 * @FilePath: \member_ship\src\views\regist.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="registBox">
    <div class="titleBox">成都市三明商会-会员登记</div>
    <van-form @submit="onSubmit">
      <van-field name="switch" label="会员类型">
        <template #input>
          <van-radio-group v-model="vipType" direction="horizontal">
            <van-radio name="0">非企业会员</van-radio>
            <van-radio name="1">企业会员</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="username"
        name="真实姓名"
        label="真实姓名"
        placeholder="真实姓名"
        :rules="[{ required: true, message: '请填写真实姓名' }]"
      />
      
       <van-field
        v-model="telNum"
        name="电话号码"
        label="电话号码"
        type="tel"
        placeholder="电话号码"
       
        :rules="[{ required: true, message: '请填写电话号码' }]"
      />
      <van-field
        v-model="macName"
        :disabled="notHavemacname"
        name="企业名称"
        label="企业名称"
        placeholder="企业名称"
        :rules="[{ required: !notHavemacname, message: '请填写企业名称' }]"
      >  </van-field>
        <van-field
        v-model="huiyuanleavel"
       
        name="会员等级"
        label="会员等级"
        placeholder="会员等级"
        @focus="openMybox2"
        :rules="[{ required: true, message: '请填写会员等级' }]"
      >
       
      </van-field>
      <van-field
        readonly
        :disabled="isFujian"
        clickable
        name="picker"
        :value="cityName"
        label="祖籍所在的"
        placeholder="点击选择城市"
        @focus="showPicker = true"
      >
        <template #button>
          <van-checkbox v-model="isFujian">非福建会员</van-checkbox>
        </template>
      </van-field>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        v-model="macNum"
        :disabled="notHavemacnum"
        name="营业执照号"
        label="营业执照号"
        placeholder="营业执照号"
        :rules="[{ required: !notHavemacnum, message: '请填写营业执照号' }]"
      >
        <template #button>
          <van-checkbox v-model="notHavemacnum">无</van-checkbox>
        </template>
      </van-field>

      <van-cell-group>
        <van-cell title="营业执照照片">
          <template #label>
            <van-image width="100" height="100" :src="macPhoto">
              <template v-slot:error>未上传</template>
            </van-image>
          </template>
          <template #default>
            <el-upload
              :disabled="notHavemacnum"
              style="margin-left:20px"
              class="upload-demo"
              action="https://www.moodsci.com/pigbox/CommodityService/uploadGoodsPicture"
              :auto-upload="true"
              multiple
              :on-success="fileDataChange2"
              :show-file-list="false"
              :limit="1"
            >
              <el-button size="mini" :disabled="notHavemacnum" type="primary">上传图片</el-button>
            </el-upload>
          </template>
        </van-cell>
        <van-cell title="身份证正面照片">
          <template #label>
            <van-image width="100" height="100" :src="cardIdAfterPhoto">
              <template v-slot:error>未上传</template>
            </van-image>
          </template>
          <template #default>
            <el-upload
              style="margin-left:20px"
              class="upload-demo"
              action="https://www.moodsci.com/pigbox/CommodityService/uploadGoodsPicture"
              :auto-upload="true"
              multiple
              :on-success="fileDataafterChange"
              :show-file-list="false"
              :limit="1"
            >
              <el-button size="mini" type="primary">上传图片</el-button>
            </el-upload>
          </template>
        </van-cell>
        <van-cell title="身份证背面照片" value="内容">
          <template #label>
            <van-image width="100" height="100" :src="cardIdBefoPhoto">
              <template v-slot:error>未上传</template>
            </van-image>
          </template>
          <template #default>
            <el-upload
              style="margin-left:20px"
              class="upload-demo"
              action="https://www.moodsci.com/pigbox/CommodityService/uploadGoodsPicture"
              :auto-upload="true"
              multiple
              :on-success="fileDataBffoChange"
              :show-file-list="false"
              :limit="1"
            >
              <el-button size="mini" type="primary">上传图片</el-button>
            </el-upload>
          </template>
        </van-cell>
      </van-cell-group>
      <van-field
        v-model="serveList"
        name="从事行业"
        label="从事行业"
        placeholder="从事行业"
        :rules="[{ required: true, message: '请填写从事行业' }]"
      />
      <van-field name="picker" :value="Level2" label="个人标签" placeholder="个人标签" @focus="openMybox">
        <template #button>
          <van-checkbox v-model="isShowTagList">自定义</van-checkbox>
        </template>
      </van-field>
      <van-popup
        v-model="showPicker2"
        closeable
        position="bottom"
        @click-close-icon="popColose"
        @click-overlay="popColose"
      >
        <div style="height:40px"></div>
        <van-checkbox-group v-model="Level">
          <van-cell-group>
            <van-cell v-for="(item, index) in tabList" clickable :key="item" :title="`${item}`">
              <template #right-icon>
                <van-checkbox :name="item" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </van-popup>

      <van-popup
        v-model="isShowHUiyPop"
        closeable
        position="bottom"
      
      >
        <div style="height:40px"></div>
        <van-radio-group v-model="huiyuanleavel">
          <van-cell-group>
            <van-cell v-for="(item, index) in tabList2" clickable :key="item" :title="`${item}`">
              <template #right-icon>
                <van-radio :name="item" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </van-popup>

      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Notify } from 'vant';
export default {
  data() {
    return {
      huiyuanleavel:"",
      isShowHUiyPop:false,
      telNum:"",
      cardIdAfterPhoto: "",
      cardIdBefoPhoto: "",
      macPhoto: "",
      isShowTagList: false,
      isFujian: false,
      notHavemacnum: false,
      notHavemacname: false,
      vipType: "1",
      username: "",
      macName: "",
      cityName: "",
      macNum: "",
      serveList: "",
      Level: [],
      Level2: "",
      showPicker: false,
      showPicker2: false,
      columns: [
        {
          text: "福州市",
          children: [
            {
              text: "鼓楼区"
            },
            {
              text: "台江区"
            },
            {
              text: "仓山区"
            },
            {
              text: "马尾区"
            },
            {
              text: "晋安区"
            },
            {
              text: "闽侯县"
            },
            {
              text: "连江县"
            },
            {
              text: "罗源县"
            },
            {
              text: "闽清县"
            },
            {
              text: "永泰县"
            },
            {
              text: "平潭县"
            },
            {
              text: "福清市"
            },
            {
              text: "长乐市"
            }
          ]
        },
        {
          text: "厦门市",
          children: [
            {
              text: "思明区"
            },

            {
              text: "海沧区"
            },
            {
              text: "湖里区"
            },
            {
              text: "集美区"
            },
            {
              text: "同安区"
            },
            {
              text: "翔安区"
            }
          ]
        },
        {
          text: "莆田市",
          children: [
            {
              text: "城厢区"
            },

            {
              text: "涵江区"
            },
            {
              text: "荔城区"
            },
            {
              text: "秀屿区"
            },
            {
              text: "仙游县"
            }
          ]
        },
        {
          text: "莆田市",
          children: [
            {
              text: "城厢区"
            },

            {
              text: "涵江区"
            },
            {
              text: "荔城区"
            },
            {
              text: "秀屿区"
            },
            {
              text: "仙游县"
            }
          ]
        },
        {
          text: "三明市",
          children: [
            {
              text: "梅列区"
            },

            {
              text: "三元区"
            },
            {
              text: "明溪县"
            },
            {
              text: "清流县"
            },
            {
              text: "宁化县"
            },
            {
              text: "大田县"
            },
            {
              text: "尤溪县"
            },
            {
              text: "沙县"
            },

            {
              text: "将乐县"
            },
            {
              text: "泰宁县"
            },
            {
              text: "建宁县"
            },
            {
              text: "永安市"
            }
          ]
        },
        {
          text: "泉州市",
          children: [
            {
              text: "鲤城区"
            },
            {
              text: "丰泽区"
            },
            {
              text: "洛江区"
            },
            {
              text: "泉港区"
            },
            {
              text: "惠安县"
            },
            {
              text: "安溪县"
            },
            {
              text: "永春县"
            },
            {
              text: "德化县"
            },
            {
              text: "金门县"
            },
            {
              text: "石狮市"
            },

            {
              text: "晋江市"
            },
            {
              text: "南安市"
            }
          ]
        },
        {
          text: "漳州市",
          children: [
            {
              text: "芗城区"
            },
            {
              text: "龙文区"
            },
            {
              text: "云霄县"
            },

            {
              text: "漳浦县"
            },
            {
              text: "诏安县"
            },

            {
              text: "长泰县"
            },
            {
              text: "东山县"
            },
            {
              text: "南靖县"
            },
            {
              text: "平和县"
            },
            {
              text: "华安县"
            },
            {
              text: "龙海市"
            }
          ]
        },
        {
          text: "南平市",
          children: [
            {
              text: "延平区"
            },
            {
              text: "顺昌县"
            },
            {
              text: "浦城县"
            },
            {
              text: "光泽县"
            },
            {
              text: "松溪县"
            },
            {
              text: "政和县"
            },
            {
              text: "邵武市"
            },
            {
              text: "武夷山市"
            },
            {
              text: "建瓯市"
            },
            {
              text: "建阳区"
            }
          ]
        },
        {
          text: "龙岩市",
          children: [
            {
              text: "新罗区"
            },
            {
              text: "长汀县"
            },
            {
              text: "永定区"
            },
            {
              text: "上杭县"
            },
            {
              text: "武平县"
            },
            {
              text: "连城县"
            },
            {
              text: "漳平市"
            }
          ]
        },
        {
          text: "宁德市",
          children: [
            {
              text: "蕉城区"
            },
            {
              text: "霞浦县"
            },
            {
              text: "古田县"
            },
            {
              text: "寿宁县"
            },
            {
              text: "周宁县"
            },
            {
              text: "柘荣县"
            },
            {
              text: "福安市"
            },
            {
              text: "福鼎市"
            }
          ]
        }
      ],
      tabList: ["建筑", "供应链", "食品", "科技", "信息化", "钢铁", "器材"],
      tabList2: ["会长", "执行会长", "监事长", "名誉会长", "秘书长", "常务副会长", "副会长","理事","会员"]
    };
  },
  methods: {
    fileDataafterChange(e) {
      this.cardIdAfterPhoto = `https://www.moodsci.com${e}`;
    },
    fileDataBffoChange(e) {
      this.cardIdBefoPhoto = `https://www.moodsci.com${e}`;
    },
    fileDataChange2(e) {
      console.log(e);
      this.macPhoto = `https://www.moodsci.com${e}`;
    },
    openMybox() {
      if (!this.isShowTagList) {
        this.showPicker2 = true;
      }
    },
    openMybox2() {
      // if (!this.isShowTagList) {
        this.isShowHUiyPop=true
      // }
    },
    popColose() {
      this.Level2 = this.Level.join(",");
    },
    onConfirm(value, index) {
      console.log(value, index);
      this.cityName = value.join("");
      this.showPicker = false;
    },
    onSubmit() {
      //  Notify({ type: "danger", message: "请上传身份证图片" });
      if (this.cardIdAfterPhoto == "" || this.cardIdBefoPhoto == "") {
        Notify({ type: "danger", message: "请上传身份证图片" });
        return
      }
      // return
      if (this.notHavemacnum) {
        this.macNum = null;
      }
      if (this.isFujian) {
        this.cityName = null;
      }
      if (this.notHavemacname) {
        this.macName = null;
      }
      if (this.notHavemacname) {
        this.macPhoto = null;
      }
      let myindex = this.tabList2.indexOf(this.huiyuanleavel)
      // console.log(myindex);
      // return
      let formData = new FormData();
      formData.append(
        "params",
        `{"Data":[{"member_name":"${this.username}","member_iffujian":"${this.vipType}","member_com":"${this.macName}","member_address":"${this.cityName}","member_qycode":"${this.macNum}","member_qycontent":"${this.serveList}","member_label":"${this.Level2}","member_zzpic":"${this.macPhoto}","member_sfzpic":"${this.cardIdAfterPhoto},${this.cardIdBefoPhoto}","member_phone":"${this.telNum}","member_level":"${this.huiyuanleavel}","member_index":"${myindex}"}]}`
      );
      this.$axios({
        method: "post",
        url: `https://www.moodsci.com/SWDataservice/sxwshop/insertSMMember`, // 接口地址
        data: formData
      }).then(res => {
        // console.log(res);
        Notify({ type: 'success', message: '注册成功' });
      });
    }
  }
};
</script>

<style>
.registBox {
  height: 100vh;
  width: 100vw;
}
.titleBox {
  height: 50px;
  width: 100%;
  /* background-color: aqua; */
  text-align: center;
  line-height: 50px;
}
.getImgBox {
  width: 50%;
  height: 100%;
  /* background-color: aqua; */
  display: flex;
  align-items: center;
}
</style>